/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import { useEuiTheme } from '../services';
/**
 * Creates a React hook from a style mixin factory.
 * The resulting hook accepts a single option property
 * in the shape of the mixin's options
 *
 * `const useStyle = createStyleHook((euiTheme, {color: string}, colorMode) => {})`
 * Results in the following with `euiTheme` and `colorMode` values automatically applied
 * `const styles = useStyle({color: string}) => void`
 */

export function createStyleHookFromMixin(mixinFactory) {
  return function (options) {
    var _useEuiTheme = useEuiTheme(),
        euiTheme = _useEuiTheme.euiTheme,
        colorMode = _useEuiTheme.colorMode;

    return mixinFactory(euiTheme, options, colorMode);
  };
}